import {
  SET_ACCESS_TOKEN,
  SET_GUEST_TOKEN,
  SET_IS_LOGGED_IN,
  SET_USER_ID,
  SET_USER_TYPE,
  SET_CUSTOMER_INFO,
  SET_IS_LOADING,
} from "@constants/action-types";

export const setAccessToken = (value) => ({
  type: SET_ACCESS_TOKEN,
  value,
});
export const setGuestToken = (value) => ({
  type: SET_GUEST_TOKEN,
  value,
});
export const setIsLoggedIn = (value) => ({
  type: SET_IS_LOGGED_IN,
  value,
});
export const setUserId = (value) => ({
  type: SET_USER_ID,
  value,
});
export const setUserType = (value) => ({
  type: SET_USER_TYPE,
  value,
});
export const setCustomerInfo = (value) => ({
  type: SET_CUSTOMER_INFO,
  value,
});
export const setIsLoading = (value) => ({
  type: SET_IS_LOADING,
  value,
});
